import { EditFilled } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Collapse,
  Form,
  Input,
  Modal,
  Radio,
  Row,
} from "antd";
import { useNavigate } from "react-router";
import { useContext, useEffect, useState } from "react";
import moment from "moment";

import downIcon from "../../assets/images/webToLead/angle-double-down.svg";
import backArrow from "../../assets/images/webToLead/back-arrow.svg";
import CreateEditCustomField from "./CreateEditCustomField";
import DeleteCustomField from "./DeleteCustomField";
import PublishLink from "./PublishLink";
import { getUserInfo } from "../../utils/utils";
import {
  configType,
  enumFieldType,
  standardFieldsOptions,
} from "../../constant/WebToLead";
import { useLeadFormActions } from "./hooks/useLeadFormActions";
import FeatureComingSoon from "../../common/FeatureComingSoon";
import { AuthContext } from "../../context/AuthContext";

const CreateForm = ({ initialValues }) => {
  const defaultCheckedList = standardFieldsOptions
    ?.filter((d) => !d?.isOptional)
    ?.map((d) => d.fieldName);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { isWebToLeadEdit } = useContext(AuthContext);
  const [isPublishOpen, setIsPublishOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirm, setConfirm] = useState(false);
  const [checkedList, setCheckedList] = useState(defaultCheckedList);
  const [editCustomField, setEditCustomField] = useState();
  const [customFields, setCustomFields] = useState([]);
  const [formType, setFormType] = useState();
  const user = getUserInfo();
  const { handleCreate, handleUpdate, loading } = useLeadFormActions(
    (error) =>
      form.setFields([
        {
          name: "formName",
          errors: [error],
        },
      ]),
    () => setConfirm(true)
  );

  const webToLeadConfigFieldsOptions = standardFieldsOptions?.map(
    (d) => d?.fieldName
  );
  const checkAll = webToLeadConfigFieldsOptions.length === checkedList.length;
  const onCheckAllChange = (e) => {
    const newCheckedList = e.target.checked
      ? webToLeadConfigFieldsOptions
      : defaultCheckedList;
    setCheckedList(newCheckedList);
    form.setFieldsValue({ webToLeadConfigFields: newCheckedList });
  };

  useEffect(() => {
    form.setFieldsValue({
      ...initialValues,
      webToLeadConfigCustomFields: initialValues?.customFields,
    });
    if (initialValues?.id) {
      setCustomFields(initialValues?.customFields);
      setCheckedList(initialValues?.webToLeadConfigFields);
      setFormType(initialValues?.configType);
    }
  }, [initialValues, form]);

  const onFinish = (values) => {
    if (initialValues?.id) {
      const payload = {
        ...values,
        id: initialValues?.id,
        webToLeadConfigFields: [
          ...checkedList?.map((d) => {
            return {
              ...standardFieldsOptions?.find((i) => i.fieldName === d),
              isSelected: true,
            };
          }),
          ...customFields?.map((d) => ({
            ...d,
            pickValues: d?.pickValues?.map((v) => ({
              value: v?.value ? v?.value : v,
            })),
          })),
        ],
      };

      handleUpdate(payload, 1, true);
    } else {
      const payload = {
        ...values,
        active: true,
        userId: user?.id,
        createdDate: new Date(),
        updatedDate: new Date(),
        webToLeadConfigFields: [
          ...checkedList?.map((d) => {
            return {
              ...standardFieldsOptions?.find((i) => i.fieldName === d),
              isSelected: true,
            };
          }),
          ...customFields?.map((d) => ({
            ...d,
            pickValues: d?.pickValues?.map((v) => ({ value: v })),
          })),
        ],
      };
      handleCreate(payload);
    }
    // if (values?.configType === configType.SHARED_URL) {
    //   setIsPublishOpen(true);
    // }
  };

  const items = [
    {
      key: "1",
      label: (
        <div
          className="heading d-flex justify-content-between"
          style={{ width: "100%" }}
        >
          <div
            className="heading18px roboto-medium text-color-1C1C1C"
            style={{
              padding: "0 5px",
              width: "100%",
              lineHeight: "26px",
            }}
          >
            Custom field to add
          </div>
        </div>
      ),
      extra: isOpen ? (
        <img src={downIcon} alt="" style={{ transform: "rotate(180deg)" }} />
      ) : (
        <img src={downIcon} alt="" />
      ),
      showArrow: false,
      children: (
        <div style={{ minHeight: 185 }}>
          <div style={{ gap: 20, flexWrap: "wrap" }} className="d-flex">
            {!!customFields?.length &&
              customFields?.map((field, i) => (
                <div
                  className="custom-field d-flex align-items-center"
                  style={{ gap: 30 }}
                  key={i}
                >
                  <Checkbox
                    value={field?.fieldName}
                    checked={field?.isSelected}
                    onChange={() => {
                      const updatedFields = customFields?.map((d) =>
                        d?.fieldName === field?.fieldName
                          ? { ...d, isSelected: !field?.isSelected }
                          : d
                      );

                      form.setFieldsValue({
                        webToLeadConfigCustomFields: updatedFields,
                      });
                      setCustomFields(updatedFields);
                    }}
                  >
                    <span style={{ paddingLeft: 12 }}>
                      {!field?.isOptional && (
                        <span className="text-required">*</span>
                      )}
                      {field?.fieldName}
                    </span>
                  </Checkbox>
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: 12 }}
                  >
                    <EditFilled
                      className="cursor-pointer"
                      onClick={() => {
                        setEditCustomField(field);
                      }}
                    />
                    <DeleteCustomField
                      fieldName={field?.fieldName}
                      onDelete={() => {
                        const updatedFields = customFields?.filter(
                          (d) => d?.fieldName !== field?.fieldName
                        );
                        form.setFieldsValue({
                          webToLeadConfigCustomFields: updatedFields,
                        });
                        setCustomFields(updatedFields);
                      }}
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="d-flex justify-content-center web-to-lead">
      <div className="font-roboto">
        <div
          className="d-flex flex-column flex-md-row justify-content-between align-items-md-center"
          style={{ gap: 20 }}
        >
          <div
            className="d-flex cursor-pointer align-items-center text-color-1C1C1C roboto-bold heading24px"
            onClick={() => navigate("/settings/web-to-lead")}
          >
            <img src={backArrow} alt="" style={{ marginRight: "15px" }} /> Web
            to Lead Setup
          </div>
          <div
            className="d-flex align-items-center justify-content-end"
            style={{ gap: 20 }}
          >
            <CreateEditCustomField
              initialValues={
                editCustomField
                  ? {
                      ...editCustomField,
                      defaultValue: [enumFieldType.DATE].includes(
                        editCustomField?.fieldType
                      )
                        ? moment(editCustomField?.defaultValue)
                        : editCustomField?.defaultValue,
                      isMandatory: !editCustomField?.isOptional,
                    }
                  : {}
              }
              existingFieldNames={[
                ...standardFieldsOptions?.map((d) => d?.fieldName),
                ...customFields
                  ?.map((d) => d?.fieldName)
                  ?.filter((i) => i !== editCustomField?.fieldName),
              ]}
              customFieldsLength={customFields?.length}
              closeEdit={() => {
                setEditCustomField();
              }}
              onCreate={(value) => {
                const custom =
                  form.getFieldValue("webToLeadConfigCustomFields") || [];
                let updated;
                if (editCustomField) {
                  updated = custom?.map((d) =>
                    d.fieldName === editCustomField?.fieldName ? value : d
                  );
                } else {
                  const required = [...custom, value]?.filter(
                    (d) => !d?.isOptional
                  );
                  const optional = [...custom, value]?.filter(
                    (d) => d?.isOptional
                  );
                  updated = [...required, ...optional];
                }
                form.setFieldsValue({
                  webToLeadConfigCustomFields: updated,
                });
                setCustomFields(updated);
              }}
            />
          </div>
        </div>
        <Form
          form={form}
          initialValues={{
            configType: configType.EMBEDDED_HTML,
            webToLeadConfigFields: defaultCheckedList,
            webToLeadConfigCustomFields: [],
            assignTo: user?.firstName + user?.lastName,
          }}
          layout="vertical"
          onFinish={onFinish}
        >
          <div className="card mt20">
            <div className="heading">
              <Checkbox onChange={onCheckAllChange} checked={checkAll}>
                <div
                  className="heading18px roboto-medium text-color-1C1C1C"
                  style={{ paddingLeft: 12 }}
                >
                  Select Fields For Lead Generation
                </div>
              </Checkbox>
            </div>
            <div className="content">
              <Form.Item name="webToLeadConfigFields">
                <Checkbox.Group
                  onChange={(list) => {
                    setCheckedList(list);
                    form.setFieldsValue({ webToLeadConfigFields: list });
                  }}
                >
                  <Row gutter={[16, 16]} style={{ rowGap: 30 }}>
                    {webToLeadConfigFieldsOptions.map((field, index) => {
                      const isChecked = defaultCheckedList?.includes(field);
                      return (
                        <Col key={index} sm={8} lg={6}>
                          <Checkbox
                            value={field}
                            disabled={isChecked}
                            className={`${isChecked ? "field-checked" : "field-item"} heading15px`}
                          >
                            <span style={{ paddingLeft: 12 }}>
                              {isChecked && (
                                <span className="text-required">*</span>
                              )}
                              {field}
                            </span>
                          </Checkbox>
                        </Col>
                      );
                    })}
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </div>
          </div>
          <Collapse
            items={items}
            onChange={() => setIsOpen(!isOpen)}
            className="mt50"
            style={{ borderRadius: "4px" }}
          />
          <Row
            gutter={[24, 24]}
            className="mt50 justify-content-between align-items-start"
          >
            <Col xs={24} lg={8}>
              <div className="d-flex flex-column">
                <Form.Item
                  label={
                    <label className="input-label heading15px">Form Name</label>
                  }
                  name="formName"
                  rules={[{ required: true, message: "Form Name is required" }]}
                >
                  <Input className="common-input" />
                </Form.Item>
              </div>
            </Col>
            <Col xs={24} lg={8}>
              <div className="d-flex flex-column">
                <Form.Item
                  label={
                    <label className="input-label heading15px">Assign To</label>
                  }
                  name="assignTo"
                  rules={[{ required: true, message: "Assign To is required" }]}
                >
                  <Input disabled className="common-input" />
                </Form.Item>
              </div>
            </Col>
            <Col xs={24} lg={8}>
              <div className="d-flex flex-column">
                <Form.Item
                  label={
                    <label className="input-label heading15px">
                      Your Domain Name
                    </label>
                  }
                  style={{ marginBottom: 0 }}
                  name="domainName"
                  rules={[
                    { required: true, message: "Please enter a domain name" },
                    {
                      pattern:
                        /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/,
                      message:
                        "Please enter a valid domain name (e.g., example.com)",
                    },
                  ]}
                >
                  <Input
                    disabled={initialValues?.id}
                    className="common-input"
                  />
                </Form.Item>
                <div
                  className="heading10px text-color-848484"
                  style={{ marginTop: 5 }}
                >
                  Example: example.com
                </div>
              </div>
            </Col>
            <Col xs={24} lg={8}>
              {formType === configType.EMBEDDED_SCRIPT && (
                <div className="d-flex flex-column">
                  <Form.Item
                    label={
                      <label className="input-label heading15px">
                        Page Slug
                      </label>
                    }
                    name="slug"
                    rules={[
                      { required: true, message: "Page Slug is required" },
                    ]}
                    style={{ marginBottom: 0 }}
                  >
                    <Input className="common-input" />
                  </Form.Item>
                  <div
                    className="heading13px text-color-848484"
                    style={{ marginTop: 5 }}
                  >
                    Note: Enter the URL slug where this form will be used. For
                    example: /contact-us or /feedback.
                  </div>
                </div>
              )}
            </Col>
          </Row>
          <div
            className="mt30 d-flex flex-column flex-lg-row justify-content-between align-items-lg-center"
            style={{ gap: 20 }}
          >
            <div
              className="d-flex flex-column flex-md-row align-items-md-center"
              style={{ gap: 20, width: "100%" }}
            >
              <div className="text-color-1F1F1F heading15px">
                What do you want to create?
              </div>
              <Form.Item
                name="configType"
                onChange={(e) => {
                  if (e.target.value !== configType.SHARED_URL) {
                    form.setFieldsValue({ configType: e.target.value });
                    setFormType(e.target.value);
                  }
                }}
                style={{ marginBottom: 0 }}
              >
                <Radio.Group className="d-flex" disabled={initialValues?.id}>
                  <Radio value={configType.EMBEDDED_HTML}>HTML</Radio>
                  <FeatureComingSoon>
                    <Radio value={configType.SHARED_URL}>Form Link</Radio>
                  </FeatureComingSoon>
                  <Radio value={configType.EMBEDDED_SCRIPT}>Script</Radio>
                </Radio.Group>
              </Form.Item>
            </div>
            <div className="d-flex justify-content-end align-items-center">
              <Button
                className="secondary-btn"
                style={{ marginRight: 20 }}
                onClick={() => navigate("/settings/web-to-lead")}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                loading={loading}
                htmlType="submit"
                className="theme-btn"
              >
                {initialValues?.id ? "Update" : "Generate"}
              </Button>
              <PublishLink
                isPublish={isPublishOpen}
                handleCancel={() => setIsPublishOpen(false)}
              />
            </div>
          </div>
        </Form>
      </div>
      <Modal
        title="Subscription expired"
        open={isConfirm}
        centered
        width={400}
        footer={[
          <Button
            key="cancel"
            className="secondary-btn"
            onClick={() => setConfirm(false)}
          >
            No
          </Button>,
          <Button
            key="ok"
            type="primary"
            className="theme-btn"
            onClick={() => {
              onFinish({ ...form.getFieldsValue(), force: true });
              setConfirm(false);
            }}
          >
            Yes
          </Button>,
        ]}
        onOk={() => setConfirm(false)}
        onCancel={() => setConfirm(false)}
      >
        Your subscription has expired, but the grace period is still active. Do
        you want to continue for up to 7 more days?
      </Modal>
    </div>
  );
};

export default CreateForm;
